import { faChalkboardTeacher, faUser, faUsers, faUserShield } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getAllUser } from '../../../../api/admin-user.api'
import DashboardCard from '../components/DashboardCard'
import SkeletonLoader from '../components/SkeletonLoader'
import StatCard from '../components/StatCard'
import { UserStatsData } from '../types/widget-data.type'

const UserStatsWidget = () => {
    const { t } = useTranslation()

    const { data: users, isLoading } = useQuery({
        queryKey: ['users'],
        queryFn: getAllUser,
    })

    if (isLoading) {
        return <SkeletonLoader showHeader itemCount={4} itemHeight="60px" />
    }

    const usersArray = Array.isArray(users) ? users : []

    const data: UserStatsData = {
        totalUsers: usersArray.length || 0,
        membersCount: usersArray.filter((u: any) => u.role === 'ROLE_MEMBER').length || 0,
        coachesCount: usersArray.filter((u: any) => u.role === 'ROLE_COACH').length || 0,
        adminsCount: usersArray.filter((u: any) => u.role === 'ROLE_ADMIN').length || 0,
        newUsersThisMonth: 0,
    }

    return (
        <DashboardCard title={t('adminDashboard.widgets.userStats.title')} icon={<FontAwesomeIcon icon={faUsers} />}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                <StatCard
                    label={t('adminDashboard.widgets.userStats.total')}
                    value={data.totalUsers}
                    icon={<FontAwesomeIcon icon={faUsers} />}
                    color="blue"
                />
                <StatCard
                    label={t('adminDashboard.widgets.userStats.members')}
                    value={data.membersCount}
                    icon={<FontAwesomeIcon icon={faUser} />}
                    color="green"
                />
                <StatCard
                    label={t('adminDashboard.widgets.userStats.coaches')}
                    value={data.coachesCount}
                    icon={<FontAwesomeIcon icon={faChalkboardTeacher} />}
                    color="purple"
                />
                <StatCard
                    label={t('adminDashboard.widgets.userStats.admins')}
                    value={data.adminsCount}
                    icon={<FontAwesomeIcon icon={faUserShield} />}
                    color="orange"
                />
            </div>
        </DashboardCard>
    )
}

export default UserStatsWidget
